/**
 * A conversa do caso entre o cliente e a equipe (E149 — GUS-149, ADR-0102 §3): a aba Conversa do
 * portal, o envio de documento complementar e a página da conversa na área da equipe.
 *
 * O que a conversa não faz aparece nas notas: ciência e questionamento não aprovam nem alteram o
 * laudo, "nova versão em preparação" não reemite, e o "responder até" é só a data que a equipe
 * informou.
 */
export const ptBRConversa = {
  titulo: 'Conversa do caso',
  carregando: 'Carregando a conversa…',
  erroCarregar: 'Não foi possível carregar a conversa. Tente novamente.',
  tentarDeNovo: 'Tentar novamente',
  vazio: 'Nenhuma mensagem ainda.',
  historicoRotulo: 'Mensagens do caso',
  quem: {
    voce: 'Você',
    equipe: 'Equipe',
    cliente: 'Cliente',
  },
  tipo: {
    mensagem: 'Mensagem',
    pedido_de_material: 'Pedido de documento',
    resposta_ao_pedido: 'Resposta ao pedido',
    complemento: 'Documento complementar',
    questionamento: 'Questionamento',
    resposta_ao_questionamento: 'Resposta ao questionamento',
    apontamento: 'Apontamento',
    resposta_ao_apontamento: 'Resposta ao apontamento',
    ciencia: 'Ciência',
  },
  situacao: {
    aberto: 'Aberto',
    atendido: 'Atendido',
    sem_documento: 'Sem o documento',
    respondido: 'Respondido',
    nova_versao: 'Nova versão em preparação',
    resolvido: 'Resolvido',
  },
  desfecho: {
    atendido: 'Documento enviado.',
    sem_documento: 'O documento não está disponível.',
    respondido: 'Respondido.',
    nova_versao:
      'Uma nova versão está em preparação. A versão entregue continua disponível e não foi alterada.',
    resolvido: 'Resolvido.',
  },
  campos: {
    material: 'Documento pedido',
    motivo: 'Motivo',
    responderAte: 'Responder até {{data}} (data informada pela equipe)',
    origem: 'Origem informada',
    campoApontado: 'Campo ou documento',
    arquivosNoCaso: 'Os arquivos estão em Documentos.',
    emRespostaA: 'Em resposta a: {{item}} de {{data}}',
  },
  recusa: {
    TIPO_NAO_CABE_AO_LADO: 'Este registro não está disponível para você neste caso.',
    ITEM_NAO_ENCONTRADO: 'O item respondido não foi encontrado. Atualize a conversa.',
    ITEM_JA_RESPONDIDO: 'Este item já foi respondido. Atualize a conversa.',
    SEM_ENTREGA: 'Disponível depois da entrega do exame.',
    TEXTO_OBRIGATORIO: 'Escreva o texto antes de enviar.',
    MATERIAL_E_MOTIVO: 'Informe o documento pedido e o motivo.',
    PRAZO_NO_PASSADO: 'A data para responder não pode estar no passado.',
    CAMPO_APONTADO_OBRIGATORIO: 'Informe o campo ou documento apontado.',
    DESFECHO_INVALIDO: 'Escolha a resposta antes de enviar.',
    MOTIVO_OBRIGATORIO: 'Informe o motivo.',
    RECEBIMENTO_NAO_CONCLUIDO: 'O envio dos arquivos ainda não foi concluído.',
    RECEBIMENTO_NAO_CABE: 'Este registro não leva arquivo.',
    CASE_NOT_FOUND: 'Caso não encontrado.',
    indisponivel: 'Não foi possível enviar agora. Tente novamente.',
  },
  compositor: {
    enviar: 'Enviar',
    enviando: 'Enviando…',
    enviado: 'Registrado na conversa.',
    cancelar: 'Cancelar',
    tipoRotulo: 'O que registrar',
  },
  portal: {
    intro:
      'Fale com a equipe que conduz o exame. O que for registrado aqui fica no caso e não se edita nem se apaga.',
    pedidosTitulo: 'Pedidos da equipe',
    enviarDocumento: 'Enviar o documento',
    naoTenho: 'Não tenho o documento',
    motivoNaoTenho: 'Por que o documento não está disponível?',
    registrarResposta: 'Registrar resposta',
    envioPeloEscritorio:
      'Neste caso, os documentos são enviados pelo escritório que o abriu. Use a conversa para combinar o envio.',
    escrever: {
      mensagem: 'Mensagem',
      apontamento: 'Apontar um campo',
      questionamento: 'Questionar a entrega',
      ciencia: 'Registrar ciência',
    },
    mensagemRotulo: 'Mensagem para a equipe',
    apontamentoCampo: 'Campo ou documento',
    apontamentoCampoDica: 'Por exemplo: CPF do tomador na CCB, ou a data da assinatura no termo.',
    apontamentoTexto: 'O que está errado',
    questionamentoTexto: 'O que você questiona no exame entregue',
    questionamentoNota:
      'O questionamento não altera o laudo entregue: a equipe responde ou registra que uma nova versão está em preparação.',
    cienciaTexto: 'Comentário (opcional)',
    cienciaNota:
      'A ciência registra que você recebeu e leu a entrega. Ela não aprova nem altera o laudo.',
  },
  equipe: {
    subtitulo:
      'Conversa com o cliente deste caso (banco e escritório). Fica registrada no histórico e não se edita nem se apaga.',
    voltar: 'Voltar ao caso',
    semPermissao: 'Você não tem acesso à conversa deste caso.',
    pendentesTitulo: 'Aguardando a equipe',
    nadaPendente: 'Nada aguardando resposta da equipe.',
    abertos: 'Questionamentos abertos: {{q}} · Apontamentos abertos: {{a}}',
    aguardandoCliente: 'Pedidos aguardando o cliente: {{n}}.',
    responder: 'Responder',
    responderRotulo: 'Resposta ao cliente',
    novaVersao: 'Registrar nova versão em preparação',
    novaVersaoNota:
      'Registra que uma nova versão será preparada. Não reemite nem altera o laudo entregue.',
    resolver: 'Registrar o que foi feito',
    resolucaoRotulo: 'O que foi feito',
    escrever: {
      mensagem: 'Mensagem',
      pedido_de_material: 'Pedir documento',
      ciencia: 'Ciência do cliente',
    },
    mensagemRotulo: 'Mensagem para o cliente',
    pedidoMaterial: 'Documento pedido',
    pedidoMotivo: 'Motivo do pedido',
    pedidoPrazo: 'Responder até (opcional)',
    pedidoPrazoNota: 'Data informada ao cliente. Ela não vence nem bloqueia nada sozinha.',
    pedidoTexto: 'Mensagem (opcional)',
    cienciaTexto: 'O que o cliente disse',
    cienciaNota:
      'Registra a ciência do cliente, por exemplo "o cliente disse que está ok". Não aprova nem libera nada.',
  },
  complemento: {
    // E165.F2.C03 (GUS-221 F04, HTML 6.8): o formulário só abre por esta ação, embaixo da lista.
    adicionar: 'Adicionar documentos',
    titulo: 'Enviar documento complementar',
    intro: 'Os arquivos entram no caso e o envio fica registrado na conversa com a equipe.',
    vinculo: 'Este envio responde a',
    semPedido: 'Nenhum pedido: complemento por iniciativa própria',
    pedido: 'Pedido: {{material}}',
    origem: 'Origem do documento (opcional)',
    origemDica: 'Por exemplo: recebido do cliente final por e-mail.',
    observacao: 'Observação (opcional)',
    dropzoneTitulo: 'Arraste os arquivos ou clique para escolher',
    dropzoneDica: 'Até 50 MB por arquivo.',
    inputRotulo: 'Escolher os arquivos do complemento',
    acimaDoLimite: 'Arquivo acima de 50 MB: ele não foi enviado.',
    enviando: 'Enviando…',
    recebido: 'Recebido.',
    // E216.F7 (GUS-317 item 9): os mesmos bytes de um arquivo do caso não entram de novo.
    jaRecebido:
      'Já recebido: idêntico a um arquivo do caso, não foi duplicado. A tentativa fica no recibo.',
    falhou: 'Não foi possível enviar este arquivo.',
    registrando: 'Registrando o envio na conversa…',
    registrado: 'Envio recebido e registrado na conversa.',
    registradoComoComplemento:
      'O pedido já tinha resposta; o envio ficou registrado como complemento.',
    naoRegistrado: 'Os arquivos entraram no caso, mas o registro na conversa falhou.',
    registrarDeNovo: 'Registrar de novo',
  },
} as const;
